<div class="table-relatorios">
  @if (isLoading()) {
    <mat-progress-bar mode="indeterminate"></mat-progress-bar>
  } @else {
    <div style="padding-top: 4px"></div>
  }
  <mat-card appearance="outlined" class="table-card">
    <div class="table-container">
      <table
        #table
        mat-table
        [dataSource]="dataSource()"
        multiTemplateDataRows
        matSort
        matSortStart="desc"
        (matSortChange)="onSortChange($event)"
        class="mat-elevation-z8 responsive-table"
      >
        @for (column of visibleColumns; track column.key) {
          <ng-container [matColumnDef]="column.key">
            @if (column.sortable) {
              <th
                mat-header-cell
                *matHeaderCellDef
                [mat-sort-header]="column.key"
              >
                {{ column.label }}
              </th>
            } @else {
              <th mat-header-cell *matHeaderCellDef>
                {{ column.label }}
              </th>
            }
            <td mat-cell *matCellDef="let element">
              @switch (column.type) {
                @case ("date") {
                  {{ formatDate(element[column.key]) }}
                }
                @case ("status") {
                  @if (element[column.key]) {
                    <mat-chip
                      [class]="
                        config().statusClassFunction
                          ? config().statusClassFunction!(
                              element[column.key].code
                            )
                          : ''
                      "
                      (click)="
                        handleClickChip(element); $event.stopPropagation()
                      "
                    >
                      {{ element[column.key].description }}
                    </mat-chip>
                  }
                }
                @case ("cities") {
                  @if (element[column.key] && element[column.key].length > 0) {
                    <span
                      [matTooltip]="element[column.key].join(', ')"
                      matTooltipPosition="above"
                      style="cursor: pointer; padding-left: 0; padding-right: 0"
                    >
                      {{ element[column.key][0] }}
                      @if (element[column.key].length > 1) {
                        <span> (+{{ element[column.key].length - 1 }}) </span>
                      }
                    </span>
                  } @else {
                    -
                  }
                }
                @default {
                  {{ element[column.key] }}
                }
              }
            </td>
          </ng-container>
        }

        <!-- Actions column -->
        @if (config().showActionsColumn && visibleActions.length > 0) {
          <ng-container matColumnDef="actions">
            <th mat-header-cell *matHeaderCellDef>Ações</th>
            <td mat-cell *matCellDef="let element">
              @if (shouldShowActionsMenu(visibleActions, element)) {
                <button
                  mat-icon-button
                  [matMenuTriggerFor]="menu"
                  aria-label="Menu de ações"
                >
                  <mat-icon>more_vert</mat-icon>
                </button>
                <mat-menu #menu="matMenu">
                  @for (action of visibleActions; track action.key) {
                    @if (shouldShowActionForItem(action, element)) {
                      <button
                        mat-menu-item
                        (click)="executeAction(action, element, $event)"
                      >
                        <mat-icon>{{ action.icon }}</mat-icon>
                        <span>{{ action.label }}</span>
                      </button>
                    }
                  }
                </mat-menu>
              }
            </td>
          </ng-container>
        }
        <!-- Individual action columns (when showActionsColumn is false) -->
        @if (!config().showActionsColumn) {
          @for (action of visibleActions; track action.key) {
            <ng-container [matColumnDef]="action.key">
              <th mat-header-cell *matHeaderCellDef>{{ action.label }}</th>
              <td mat-cell *matCellDef="let element">
                @if (shouldShowActionForItem(action, element)) {
                  <button
                    mat-icon-button
                    [attr.aria-label]="action.label"
                    (click)="executeAction(action, element, $event)"
                  >
                    <mat-icon>{{ action.icon }}</mat-icon>
                  </button>
                }
              </td>
            </ng-container>
          }
        }

        <ng-container matColumnDef="expandedDetail">
          <td
            mat-cell
            *matCellDef="let element"
            [attr.colspan]="displayedColumns.length"
          >
            <div
              class="requests-element-detail-wrapper"
              [class.requests-element-detail-wrapper-expanded]="
                isExpanded(element)
              "
            >
              <div class="requests-element-detail">
                @if (expandedDetailTemplate) {
                  <ng-container
                    *ngTemplateOutlet="
                      expandedDetailTemplate;
                      context: { $implicit: element }
                    "
                  ></ng-container>
                } @else {
                  <p>
                    Conteúdo do resumo para: {{ element.areaIdentification }}
                  </p>
                }
              </div>
            </div>
          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>

        <tr
          mat-row
          *matRowDef="let row; columns: displayedColumns"
          class="requests-element-row"
          [class.requests-expanded-row]="isExpanded(row)"
          (click)="toggle(row)"
        ></tr>
        <tr
          mat-row
          *matRowDef="let row; columns: ['expandedDetail']"
          class="requests-detail-row-tr"
          [style.display]="isExpanded(row) ? 'table-row' : 'none'"
        ></tr>
      </table>
      @if (!isLoading() && (!dataSource || dataSource().data.length === 0)) {
        <div class="no-data-message" style="text-align: center; padding: 24px">
          Nenhum dado disponível
        </div>
      }
    </div>
  </mat-card>
  <!-- Pagination -->
  <mat-paginator
    #paginator
    [length]="length()"
    (page)="onPageChange($event)"
    showFirstLastButtons
    aria-label="Selecionar página"
  ></mat-paginator>
</div>
